export const errorFallbackSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="260" height="160" viewBox="0 0 800 600">
      <circle cx="400" cy="300" r="200" fill="#F2F2F2" />
      <rect x="250" y="250" width="300" height="200" fill="#FFFFFF" stroke="#CCCCCC" strokeWidth="4" />
      <line x1="350" y1="350" x2="450" y2="350" stroke="#FF6B6B" strokeWidth="12" />
      <line x1="350" y1="380" x2="450" y2="380" stroke="#FF6B6B" strokeWidth="12" />
    </svg>
  );
};
